import {useEffect, useState} from "react";
import useSWR from "swr";
import axios from "axios";
import { fetcher, host, ella } from '../utils'
import { IApp } from "../app";

import Question from "./poll/question";
import Result from "./poll/result";
import Modal from "./modal";


const Poll = ({id, type}: IApp) => {
  const dataUrl = `${host}/services/quiz/get/${id}`;
  const resultsUrl = `${ella}/services/promo/${type}/${id}`;
  const pollUrl = `${ella}/services/promo/poll/`;
  const ipUrl = `${ella}/services/promo/collect/`
  const { data, error } = useSWR(dataUrl, fetcher)
  const [ step, setStep ] = useState<number>(0);
  const [ storage, setStorage ] = useState<any>({});
  const [ results, setResults ] = useState<any>({});
  const [ modal, setModal ] = useState<any>(0);

  useEffect(() => {
    setStorage(JSON.parse(localStorage.getItem(`${type}_${id}`) || "{}"))
    // Get results
    ;(async ()=>{
      setResults({...results, [step]: await fetcher(`${resultsUrl}/${step}/`)})
    })()
  }, [step])

  useEffect(() => {
    if(!data || !storage) return
    const qL = data?.questions?.length
    const sL = Object.keys(storage).length
    // If all questions are answered set modal to 2 and never show it again
    if (sL == qL && step+1 < qL) setModal(2)
    // If modal is not 2 and we have reached the last question
    if (qL != 1 && step+1 == qL && step+1 == sL && modal != 2) setModal(1)
  }, [data, storage, step])


  const sendResults = async (pollId: number, qId: number, aId: number) => {
    const headers = {'x-requested-with': 'INCREDIBLYCOMPLICATEDTOKEN'}
    let response = await axios.get(ipUrl);
    const r = {
      section: qId,
      vote: aId,
      ip: response?.data?.ip || '0.0.0.0',
      id: data.id,
      title: data.title,
      answers: data?.questions[qId]?.answers.length,
      sections: data?.questions.length,
      answer: data?.questions[qId].answers[aId].answer,
      question: data?.questions[qId].question,
      created: new Date()
          .toISOString()
          .slice(0, 19)
          .replace(/-/g, "/")
          .replace("T", " "),
    }
    console.log('Poll data sent:', r)
    await axios.post(`${pollUrl}${pollId}/${qId}/`, r, {headers});
  }
  
  const save = (qId: number, aId: number) => {
    return () => {
      var data = JSON.parse(localStorage.getItem(`${type}_${id}`) || "{}")
      data[qId] = {
        type,
        id,
        question: qId,
        answer: aId,
        timestamp: new Date().getTime(),
      }
      localStorage.setItem(`${type}_${id}`, JSON.stringify(data))
      setStorage(data)

      // Send Data
      sendResults(id, qId, aId)
    }
  }



  return <>
  <div className={`pollquiz ${type}`}>
    {data?.image && <img className="img" src={`${host}/${data?.image}`} alt="Naslovna slika" />}
    {!storage[step] && <Question q={data?.questions[step]} helpers={{save, storage, step}} />}
    {storage[step] && <Result q={data?.questions[step]} helpers={{results, step}}/>}
    <br />
    <div className="buttons">
      {step > 0 && <button className="btn" onClick={()=>setStep(step-1)}>◀ &nbsp; Nazaj</button>}
      {data?.questions?.length > step + 1 && <button className="btn" disabled={!storage[step]} onClick={()=>setStep(step+1)}>Naprej &nbsp; ▶</button>}
    </div>
    {modal == 1 && <Modal text="Hvala za sodelovanje!" helpers={{setModal}} />}
  </div>
  
  <style jsx="true">
    {`
      .pollquiz {
        --space: 2rem;

        max-width: 95rem;
        font-size: 1.6rem;
        padding: var(--space);
        background-color: white;
        .img {
          display: block;
          width: calc(100% + var(--space) * 2);
          margin: calc(var(--space) * -1)
                  calc(var(--space) * -1)
                  var(--space)
                  calc(var(--space) * -1);
        }
      }

      .buttons {
        display: flex;
        .btn {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 3rem;
          font-size: 1.4rem;
          color: white;
          padding: 0 2rem;
          border-radius: 0.5rem;
          background-color: black;
          cursor: pointer;
          box-shadow: none;
          border: none;

          &:last-child {
              margin-left: auto;
          }

          &:disabled {
              background-color: grey;
              cursor: not-allowed;
          }
        }
      }
    `}
  </style>
  </>
}



export default Poll;  